var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7129_33090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66289 8.66404C6.9492 9.04679 7.31446 9.36349 7.73393 9.59267C8.15339 9.82184 8.61723 9.95812 9.09399 9.99226C9.57076 10.0264 10.0493 9.95762 10.4971 9.79056C10.945 9.6235 11.3516 9.36209 11.6896 9.02404L13.6896 7.02404C14.2968 6.39537 14.6327 5.55336 14.6251 4.67937C14.6175 3.80538 14.267 2.96934 13.649 2.35131C13.0309 1.73328 12.1949 1.38272 11.3209 1.37513C10.4469 1.36753 9.6049 1.70351 8.97623 2.31071L7.82956 3.45071M9.32956 7.33071C9.04326 6.94795 8.67799 6.63125 8.25853 6.40208C7.83906 6.17291 7.37522 6.03663 6.89846 6.00248C6.4217 5.96834 5.94317 6.03713 5.49533 6.20419C5.04749 6.37124 4.64082 6.63266 4.30289 6.97071L2.30289 8.97071C1.6957 9.59938 1.35972 10.4414 1.36731 11.3154C1.37491 12.1894 1.72547 13.0254 2.3435 13.6434C2.96153 14.2615 3.79757 14.612 4.67156 14.6196C5.54555 14.6272 6.38755 14.2912 7.01623 13.684L8.15623 12.544",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7129_33090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.28304479cde54df7b322b90440c39c9c.svg";
export { ForwardRef as ReactComponent };